'use client';

import { useRef } from 'react';
import { useProgressInViewport } from '../../hooks/scroll/useProgressInViewport';

import { getCompressedAssetUrl } from 'lib/config/assetUrls';
import { useLottieAnimation } from 'hooks/animation/useLottieAnimation';
import styles from './Track.module.css';

const trackGraph = getCompressedAssetUrl('/m1/track-section-graph.png');
const trackingLights = getCompressedAssetUrl('/home-track-section-lights.png');

export const Track = ({ className }: { className?: string }) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const graphRef = useRef<HTMLDivElement>(null);
  const colorsRef = useRef<HTMLDivElement>(null);
  const textRef = useRef<HTMLDivElement>(null);
  const animContainerRef = useRef<HTMLDivElement>(null);

  useProgressInViewport({
    containerRef,
    startAtZero: false,
    callback: (progress) => {
      if (!graphRef.current || !colorsRef.current || !textRef.current) {
        return;
      }

      if (progress < 0) {
        graphRef.current.style.opacity = `${1 + progress * 1}`;
        colorsRef.current.style.opacity = `${1 + progress * 1}`;
        textRef.current.style.opacity = `${(1 + progress * 1) * 2}`;
        return;
      }

      graphRef.current.style.opacity = `1`;
      colorsRef.current.style.opacity = `1`;
      textRef.current.style.opacity = `1`;

      if (
        progress > 0 &&
        animationRef.current &&
        animationRef.current.isPaused
      ) {
        animationRef.current.play();
      }
    },
  });

  const animationRef = useLottieAnimation(animContainerRef, {
    path: '/track-metabolic.json',
    renderer: 'svg',
    loop: true,
    autoplay: false,
  });

  return (
    <div
      className={className ? `${styles.root} ${className}` : styles.root}
      ref={containerRef}
    >
      <div
        className={styles.colors}
        ref={colorsRef}
        style={{ ['--track-lights' as any]: `url(${trackingLights})` }}
      />
      <div className={`${styles.container} u-grid`}>
        <h3 className={styles.text} ref={textRef}>
          Track your glucose in real time, and maximize your diet and exercise
        </h3>
        <div
          className={styles.trackGraph}
          ref={graphRef}
          style={{ ['--track-graph' as any]: `url(${trackGraph})` }}
        >
          <div />
          <div ref={animContainerRef} />
        </div>
      </div>
    </div>
  );
};
